import { render, staticRenderFns } from "./RiskDisclosure.vue?vue&type=template&id=1bd8af9b&scoped=true&"
import script from "./RiskDisclosure.vue?vue&type=script&lang=ts&"
export * from "./RiskDisclosure.vue?vue&type=script&lang=ts&"
import style0 from "./RiskDisclosure.vue?vue&type=style&index=0&id=1bd8af9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8af9b",
  null
  
)

export default component.exports